module.exports = __webpack_public_path__ + "img/AT0000002413266.20a9b56b.svg";